import { type NavItem } from '@/config/navConfig';

/** The bar shows this many destinations as tabs; the rest sit under More. Jason, 2026-10-31: "five destinations". */
export const TOP_BAR_TAB_COUNT = 5;

/**
 * The tabs are the first TOP_BAR_TAB_COUNT destinations of the rail's primary and organize groups, in navConfig
 * order (for an OWNER at the org level: Dashboard, Operations Board, Jobs / Claims, Offices, Equipment); every other
 * destination, including the measure and configure groups, is under More.
 */
export function splitTopBarNav(groups: { primary: NavItem[]; organize: NavItem[]; measure: NavItem[]; configure: NavItem[] }): { tabs: NavItem[]; more: NavItem[] } {
    const ordered = [...groups.primary, ...groups.organize];
    return { tabs: ordered.slice(0, TOP_BAR_TAB_COUNT), more: [...ordered.slice(TOP_BAR_TAB_COUNT), ...groups.measure, ...groups.configure] };
}


/** The account menu's profile link for the current scope (the top bar and the phone app bar share it). */
export function profileLinkFor(activeOfficeId: string | null, activeDepartmentId: string | null): string {
    if (activeOfficeId && activeDepartmentId) return `/office/${activeOfficeId}/department/${activeDepartmentId}/profile`;
    if (activeOfficeId) return `/office/${activeOfficeId}/profile`;
    return '/profile';
}
